import React, { useState } from "react";
import "../css/mobileapp.css";
import { FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import logo1 from "../assets/logo.png"; 


export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ செய்தி வெற்றிகரமாக அனுப்பப்பட்டது!");
    setForm({ name: "", phone: "", message: "" });
  };

  return (
        <div className="mobile-container">
      {/* HEADER */}
<div className="mobile-header">
  <img src={logo1} alt="TVK Logo" className="mobile-logo" />
</div>
    <div className="contact-page">
      {/* HEADER */}
      <h2 className="contact-title">தொடர்பு கொள்ள</h2>

      {/* INFO CARDS */}
      <div className="contact-cards">
        <a href="tel:+919092544162" className="contact-card">
          <FaPhoneAlt />
          <span>Call Us</span>
        </a>

        <a
          href="https://wa.me/+919787568747"
          target="_blank"
          rel="noreferrer"
          className="contact-card whatsapp"
        >
          <FaWhatsapp />
          <span>WhatsApp</span>
        </a>

        <div className="contact-card">
          <FaMapMarkerAlt />
          <span>
            தமிழக வெற்றி கழகம் பேரூர் அலுவலகம்,
                திற்பரப்பு,
                திருவட்டார் வடக்கு ஒன்றியம்,
                குமரி மத்திய மாவட்டம்,
                தமிழ்நாடு, இந்தியா
        </span>
        </div>

        <div className="contact-card">
          <FaEnvelope />
          <span>tvk.thirparappu.official@gmail.com</span>
        </div>
      </div>

      {/* FORM */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="உங்கள் பெயர்"
          value={form.name}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="மொபைல் எண்"
          value={form.phone}
          onChange={handleChange}
          required
        />

        <textarea
          name="message"
          placeholder="உங்கள் செய்தி..."
          rows="4"
          value={form.message}
          onChange={handleChange}
          required
        />

        <button type="submit"> அனுப்பு</button>
      </form>
    </div>
    </div>
  );
}

